import { computed, toValue } from "vue";
import { useI18n } from "vue-i18n";
import { addressRegionSet } from "../utils/addressFieldConfig";
// Canadian values are the ISO 3166-2:CA abbreviations because the one-line
// preview prints them verbatim ("Toronto, ON M5V 3L9") and the CA_FR format
// detection keys on region === "QC" (see formatAddress.ts).
const CA_PROVINCES = [
    { value: "AB", labelKey: "alberta" },
    { value: "BC", labelKey: "britishColumbia" },
    { value: "MB", labelKey: "manitoba" },
    { value: "NB", labelKey: "newBrunswick" },
    { value: "NL", labelKey: "newfoundlandAndLabrador" },
    { value: "NS", labelKey: "novaScotia" },
    { value: "NT", labelKey: "northwestTerritories" },
    { value: "NU", labelKey: "nunavut" },
    { value: "ON", labelKey: "ontario" },
    { value: "PE", labelKey: "princeEdwardIsland" },
    { value: "QC", labelKey: "quebec" },
    { value: "SK", labelKey: "saskatchewan" },
    { value: "YT", labelKey: "yukon" },
];
// French values are the region names, consistent with how the country field
// stores "France"/"Pays-Bas" rather than ISO codes.
const FR_REGIONS = [
    { value: "Auvergne-Rhône-Alpes", labelKey: "auvergneRhoneAlpes" },
    { value: "Bourgogne-Franche-Comté", labelKey: "bourgogneFrancheComte" },
    { value: "Bretagne", labelKey: "bretagne" },
    { value: "Centre-Val de Loire", labelKey: "centreValDeLoire" },
    { value: "Corse", labelKey: "corse" },
    { value: "Grand Est", labelKey: "grandEst" },
    { value: "Hauts-de-France", labelKey: "hautsDeFrance" },
    { value: "Île-de-France", labelKey: "ileDeFrance" },
    { value: "Normandie", labelKey: "normandie" },
    { value: "Nouvelle-Aquitaine", labelKey: "nouvelleAquitaine" },
    { value: "Occitanie", labelKey: "occitanie" },
    { value: "Pays de la Loire", labelKey: "paysDeLaLoire" },
    { value: "Provence-Alpes-Côte d'Azur", labelKey: "provenceAlpesCoteDAzur" },
    { value: "Guadeloupe", labelKey: "guadeloupe" },
    { value: "Martinique", labelKey: "martinique" },
    { value: "Guyane", labelKey: "guyane" },
    { value: "La Réunion", labelKey: "laReunion" },
    { value: "Mayotte", labelKey: "mayotte" },
];
const REGIONS = {
    FR: { prefix: "fr", entries: FR_REGIONS },
    CA: { prefix: "ca", entries: CA_PROVINCES },
    NONE: { prefix: "fr", entries: [] },
};
export function useAddressRegionOptions(addressCountry, workspaceCountry) {
    const { t } = useI18n();
    return computed(() => {
        const { prefix, entries } = REGIONS[addressRegionSet(toValue(addressCountry), toValue(workspaceCountry))];
        return entries.map((entry) => ({
            value: entry.value,
            label: t(`organisation.detail.options.region.${prefix}.${entry.labelKey}`),
        }));
    });
}
